import { render, staticRenderFns } from "./CaseDetailProfile.vue?vue&type=template&id=beb2cac4&scoped=true&"
import script from "./CaseDetailProfile.vue?vue&type=script&lang=js&"
export * from "./CaseDetailProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb2cac4",
  null
  
)

export default component.exports